import Vue from "vue";

import App from "./App.vue";
import router from "./router";
import store from "@/store";

import Clipboard from "v-clipboard";
import VueToastify from "vue-toastify";

Vue.use(Clipboard);
Vue.use(VueToastify, {
  successDuration: 2000,
  errorDuration: 4000,
  hideProgressbar: true,
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
